import React, { useEffect, useState, Fragment, memo } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  configuracionFormAction,
 
  obtenerAntecedentesCaso,
  ObtenerHitosCaso
} from '../store/actions/caso-general-action'
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { obtenerGrillaImplicado } from '../store/actions/implicado-action'
const DatosGenerales = memo(({setDatosCaso}) => {
  const [loading, setLoading]=useState(false)
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form, antecedentesCasos, llaves } = data_datos_generales

  // El hook useDispatch (redux) permite invocar una action.
  const dispatch = useDispatch()
  useEffect(() => {
    if (llaves) {
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({
          idOrgCaso: llaves['idOrgCaso'],
          idCaso: llaves['idCaso']
        })
      ).toString('base64')
      dispatch(obtenerAntecedentesCaso(query)).then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 37, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction(query))
        }
      }).then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 33, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          //dispatch(configuracionFormAction33(query))
        }
      })
      /* .then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 37, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction(query))
        }
      }) */
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({
            idOrgCaso: llaves['idOrgCaso'],
            idCaso: llaves['idCaso']
          })
        ).toString('base64')
        dispatch(obtenerGrillaImplicado(query))
      })
      // .then(()=>{
      //   let query = Buffer.from(
      //     JSON.stringify({
      //       "tipoGestion":235001,
      //        "idOrganizacion":llaves['idOrgCaso'],
      //       "idCaso":llaves['idCaso'], 
      //     })
      //   ).toString('base64')
      //   dispatch(ObtenerHitosCaso(query))
      // })
      .then(()=>setLoading(false))
    }
  }, [dispatch, llaves])

  useEffect(() => {
    if (antecedentesCasos && setDatosCaso) {
      setDatosCaso(antecedentesCasos?.antecedentesCasos[0]);
    }
  }, [antecedentesCasos])


  return (
    <>
      <LoadingComponent show={loading}/>
    
   
      {cfg_form ? (
        <Form.Group className='mb-3'>
        <div>
          <Row>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-siniestro']}
              </Form.Label>{' '}
              <br />
              <Form.Text className='mb-3'>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos?.antecedentesCasos[0]['Siniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-fechasiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'FechaSiniestroFormat'
                    ]
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-tiposiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['TipoSiniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-situacionsiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['EstadoSiniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-tipogestion']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['TipoGestion']
                  : null}
              </Form.Text>
            </Col>
          </Row>
          <Row md='10'>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-ciudadocu']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['CiudadOcurrencia']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-tab-detcaso-politem']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['Poliza'] +
                    ' / ' +
                    antecedentesCasos.antecedentesCasos[0]['Item']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-patente']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['Patente']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-seguroter']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['SeguroTercero']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-estadocaso']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['EstadoCaso']
                  : null}
              </Form.Text>
            </Col>
          </Row>
          <Row md='10'>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-contratante']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['NombreContratante']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-corredor']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['Corredor']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-analistarecdef']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['AnalistaRecDef']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-responsable']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'ResponsableAsignado'
                    ]
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['casograldefensa-lbl-fechaasig']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'FechaAsignacionFormat'
                    ]
                  : null}
              </Form.Text>
            </Col>
          </Row>
        </div>
    </Form.Group>
      ) : null}
    </>
  )
})

export default DatosGenerales
